import type { TCombinedSearchResults, TSearchResultType } from '@/types/search'

/**
 * Mirrors the Projects page tab order, then the Docs page tab order.
 */
const resultTypeOrder: TSearchResultType[] = [
  'project',
  'flipbook',
  'audiobook',
  'PrintBook',
  'KindleBook',
  'cover',
  'presentation',
  'Standard',
  'Audio',
  'TemiJob',
  'AudioBook',
]

export function sortSearchResults(results: TCombinedSearchResults): TCombinedSearchResults {
  return results.sort((a, b) => {
    const orderDiff = resultTypeOrder.indexOf(a.result_type) - resultTypeOrder.indexOf(b.result_type)

    if (orderDiff !== 0) {
      return orderDiff
    }

    return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  })
}
